module.exports = __webpack_public_path__ + "nailed-it-mockup.svg?b58f79bba663c9aead52d91afc817eca";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/nailed-it-mockup.svg
// module id = 316
// module chunks = 0